import { render } from "./PatientReportsListView.vue?vue&type=template&id=065abac8&scoped=true"
import script from "./PatientReportsListView.vue?vue&type=script&lang=js"
export * from "./PatientReportsListView.vue?vue&type=script&lang=js"

import "./PatientReportsListView.vue?vue&type=style&index=0&id=065abac8&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065abac8"]])

export default __exports__